import '../scss/app.scss';
import * as ready from "./functions/ready";
import * as navigation from "./components/navigation";

ready.ready(function () {
  navigation.navigationTrigger('[data-navigation-trigger]');
});
